import { FormsModule } from '@angular/forms';
import { RenameLabelPipe } from './../shared/pipes/rename-label.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TemplatesRoutingModule } from './templates-routing.module';
import { HomeComponent } from './home/home.component';

import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductListComponent } from './product-list/product-list.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { IncludesModule } from '../includes/includes.module';
import { Ng5SliderModule } from 'ng5-slider';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ContactUsComponent } from './contact-us/contact-us.component';
// import { NgHighlightModule } from 'ngx-text-highlight';
import { AccessoryCatComponent } from './accessory-cat/accessory-cat.component';
import { AccessoryListComponent } from './accessory-list/accessory-list.component';
import { AccessoryDetailComponent } from './accessory-detail/accessory-detail.component';
import { SafeHtmlPipe } from '../shared/pipes/safe-html.pipe';
import { AgmCoreModule } from '@agm/core';
@NgModule({
    declarations: [
        HomeComponent,
        ProductDetailComponent,
        ProductListComponent,
        SearchResultComponent,
        RenameLabelPipe,
        ContactUsComponent,
        AccessoryCatComponent,
        AccessoryListComponent,
        AccessoryDetailComponent,
        SafeHtmlPipe
    ],
    imports: [
        CommonModule,
        TemplatesRoutingModule,
        SlickCarouselModule,
        NgbPaginationModule,
        IncludesModule,
        Ng5SliderModule,
        FormsModule,
        // NgHighlightModule,
        // AgmCoreModule.forRoot({
        //     apiKey: 'AIzaSyCx4LxN-jUcpHxnVVWmvykS_hBLYF9Cvbk'
        // })
    ],
    exports: [SafeHtmlPipe, RenameLabelPipe]
})
export class TemplatesModule {}
